/**
 * PrivacyPolicyModal — opens overlaid on top of the current page (no
 * navigation, no fresh tab). The visitor's form state is preserved because
 * the modal is rendered as a sibling overlay rather than via a route change.
 *
 * Used by:
 *   - RegisterPage (inline link from the LGPD consent checkbox)
 *   - any place we want a quick read without navigating away
 *
 * Note: we wrap the radix Dialog so the body remains scrollable and the
 * "X" close + click-outside-to-close are both wired automatically.
 */
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { PrivacyPolicyBody } from "../lib/privacyPolicyContent";

export default function PrivacyPolicyModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl max-h-[85vh] overflow-hidden flex flex-col p-0 gap-0"
        data-testid="privacy-policy-modal"
      >
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="sr-only">Política de Privacidade</DialogTitle>
        </DialogHeader>
        {/* Scrollable inner panel — the modal itself stays fixed while the
            policy text scrolls inside. */}
        <div className="overflow-y-auto px-6 pb-6 flex-1" data-testid="privacy-policy-scroll">
          <PrivacyPolicyBody />
        </div>
      </DialogContent>
    </Dialog>
  );
}
